import { Box, CircularProgress, Container, Typography, Snackbar, Alert } from '@mui/material';
import { format } from 'date-fns';
import { useState } from 'react';
import FiltersBar from '../components/FiltersBar';
import FinanceiroTable, { FinanceiroModal } from '../components/tables/FinanceiroTable';
import FinanceiroCards from '../components/cards/FinanceiroCards';

const Financeiro = () => {
  const [contrato, setContrato] = useState([]);
  const [centro, setCentro] = useState([]);
  const [equipe, setEquipe] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  
  const [financeiroData, setFinanceiroData] = useState([]);
  const [comparativoData, setComparativoData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalAberto, setModalAberto] = useState(false);
  const [contratoSelecionado, setContratoSelecionado] = useState(null);
  const [contratosSemDados, setContratosSemDados] = useState([]);

  const handleCarregar = async () => {
    setLoading(true);
    setContratosSemDados([]);
    
    const apiUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
    const formatDate = (date) => (date ? format(date, 'yyyy-MM-dd') : null);

    const payload = {
      des_contrato: contrato.length === 0 ? [] : contrato,
      des_centro_servico: centro.length === 0 ? [] : centro,
      des_equipe_cms: equipe.length === 0 ? [] : equipe,
      'data-referencia-inicio': formatDate(startDate),
      'data-referencia-fim': formatDate(endDate),
    };

    const payloadComparativo = {
      des_contrato: contrato.length === 0 ? [] : contrato,
      des_centro_servico: centro.length === 0 ? [] : centro,
      des_equipe_cms: equipe.length === 0 ? [] : equipe,
      'data-referencia-fim': formatDate(endDate) || formatDate(new Date()),
    };

    try {
      const [respContrato, respComparativo] = await Promise.all([
        fetch(`${apiUrl}/producao-prevista-realizada-rev1-contrato`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }),
        fetch(`${apiUrl}/producao-comparativo-trimestral-movel`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payloadComparativo),
        }),
      ]);

      if (!respContrato.ok || !respComparativo.ok) {
        throw new Error('HTTP error!');
      }

      const dataContrato = await respContrato.json();
      const dataComparativo = await respComparativo.json();

      const mappedData = dataContrato.map(item => ({
        contrato: item.des_contrato,
        previsto: item.meta_prevista,
        realizado: item.producao_realizada,
      }));
      const uniqueData = mappedData.filter((item, index, self) =>
        index === self.findIndex(t => t.contrato === item.contrato)
      );
      setFinanceiroData(uniqueData);
      setComparativoData(dataComparativo);

      if (contrato.length > 0) {
        const contratosRetornados = uniqueData.map(d => d.contrato);
        const semDados = contrato.filter(c => !contratosRetornados.includes(c));
        setContratosSemDados(semDados);
      } else {
        setContratosSemDados([]);
      }

    } catch (error) {
      console.error('Erro ao buscar dados financeiros:', error);
      setFinanceiroData([]);
      setComparativoData(null);
    } finally {
      setLoading(false);
    }
  };

  // DESABILITADO: Carregar dados na montagem inicial da página
  // Agora os dados só são carregados ao clicar no botão "Carregar"
  // useEffect(() => {
  //   handleCarregar();
  // }, []);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Análise Financeira
      </Typography>
      <FiltersBar
        contrato={contrato}
        setContrato={setContrato}
        centro={centro}
        setCentro={setCentro}
        equipe={equipe}
        setEquipe={setEquipe}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        onCarregar={handleCarregar}
        availablePeriods={['ultima-semana', 'ultimo-mes', 'trimestral']}
        maxDateRange={95}
      />
      <Box sx={{ mt: 4 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <FinanceiroCards
              dataContrato={financeiroData}
              comparativoTrimestral={comparativoData}
            />
            <Box sx={{ mt: 2 }}>
              <FinanceiroTable data={financeiroData} onRowClick={(row) => { setContratoSelecionado(row.contrato); setModalAberto(true); }} />
            </Box>
            <FinanceiroModal 
              open={modalAberto} 
              onClose={() => setModalAberto(false)} 
              contrato={contratoSelecionado}
              data={financeiroData}
            />
            <Snackbar 
              open={contratosSemDados.length > 0} 
              autoHideDuration={6000} 
              onClose={() => setContratosSemDados([])}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
              <Alert severity="warning" onClose={() => setContratosSemDados([])}>
                {contratosSemDados.length === 1 
                  ? `Contrato não possui dados: ${contratosSemDados[0]}` 
                  : `${contratosSemDados.length} contratos não possuem dados: ${contratosSemDados.join(', ')}`}
              </Alert>
            </Snackbar>
          </>
        )}
      </Box>
    </Container>
  );
};

export default Financeiro; 